export default __webpack_public_path__ + "a419854058b1d9b6524a5559baf4714b.png";